import React from 'react'
import { Modal, Button, Checkbox, Card, Icon, Loader } from 'semantic-ui-react'
import { dispatch } from '@rematch/core';
import LoadingComponent from "./../../../../common/LoadingComponent";
import logo from "./../../../../../images/logo/logo-full-black.png";
import ModalHeader from './../../../../drive/ModalHeader'
import ModalFooter from './../../../../drive/ModalFooter'
import { Form } from 'formsy-semantic-ui-react';
import ImageResizer from './../../../../drive/ImageResizer/ImageResizer'
import defaultImage from './../../../../../images/logo/logo-128.png'
class AccountRegistration extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,
            name: props.accountData.name,
            authorizedCheckFlag: false,
            updatedImage: defaultImage,
            openImageModal: false
        }
        this.onSubmitAccountUpdate = this.onSubmitAccountUpdate.bind(this);
        this.updateText = this.updateText.bind(this)
    }

    openImageModal = (open) => {
        this.setState({ openImageModal: open })
    }

    cloudinaryImage = (imageData) => {
        this.setState({ loader: true })
        if (imageData && imageData.data) {
            this.setState({ updatedImage: imageData.data.secure_url, loader: false })
            dispatch.registerAccount.setAccountLogoImage(imageData.data.secure_url);
            let payload = {
                _id: this.props.selectedAccount._id,
                logo: imageData.data.secure_url
            }
            dispatch.registerAccount.UpdateAccountDetails(payload)

        }
    }

    handleClose = () => {
        this.setState({ open: false });
    }

    updateText(e) {
        dispatch.registerAccount.setStateAccountName(e.target.value)
    }

    authorizedCheck = (event, data) => {
        this.setState({ authorizedCheckFlag: data.checked });
    }

    onSubmitAccountUpdate(formData) {
        this.props.accountData.name = formData.name;
        this.props.accountData.logo = this.props.accountLogoObjectCloudinary && this.props.accountLogoObjectCloudinary.secure_url
            ? this.props.accountLogoObjectCloudinary.secure_url : this.props.accountData.logo;
        this.props.accountData.accountSetupStateNumber = 1;
        dispatch.registerAccount.UpdateAccountDetails(this.props.accountData);
    }

    render() {
        const errorLabel = <div className="customErrorLabel" />;
        return (
            <Modal
                className="basicModal accountModal"
                centered
                open={this.state.open}
                size='tiny'
            >
                <ModalHeader
                    header={<img src={`${logo}`} alt="Logo" />}
                    subHeader="Welcome!" />
                <LoadingComponent active={this.props.updateAccountLoader} message="Loading..." />
                <div className="ModalContent ">
                    <div className=" middleBox">
                        <p>Following details will help us to setup your account.</p>

                        <Form noValidate
                            ref={ref => this.form = ref}
                            className="formcyForm"
                            name="issue"
                            id="issueid"
                            onValidSubmit={this.onSubmitAccountUpdate}
                        >
                            <Form.Input
                                required
                                name="name"
                                id="name"
                                label="Account Name"
                                onChange={(event) => this.updateText(event)}
                                value={this.props.accountData.name}
                                validations="isWords"
                                validations={{ matchRegexp: new RegExp(/^[^-\s][\s\S]{0,127}$/) }}
                                errorLabel={errorLabel}
                                validationErrors={{
                                    matchRegexp: 'Max character limit is 128.',
                                    isDefaultRequiredValue: 'Account name is required',
                                }}
                                instantValidation
                            />
                            <p className="accountImageCardHeader">Account Logo</p>
                            <Card className="accountLogoCard" >
                                <Card.Content >
                                    <div >
                                        {this.state.loader ? <Loader active /> : null}
                                        <img src={this.state.updatedImage} className="fitImage" alt="Image" />
                                        <Button type="button" className="circular_24_icon first-rectangle-image" icon='pencil' onClick={() => this.openImageModal(true)} />
                                    </div >
                                </Card.Content>
                            </Card>
                            <ImageResizer
                                image={this.state.updatedImage}
                                openImageModal={this.openImageModal}
                                cloudinaryImage={this.cloudinaryImage}
                                open={this.state.openImageModal}
                                envData={this.props.envData}
                                width={180}
                                height={100}
                            />

                            <p><Checkbox label='I authorize usage of uploaded logo on aspenify account'
                                onChange={(event, data) => this.authorizedCheck(event, data)}
                                checked={this.state.authorizedCheckFlag} /></p>

                            <Button
                                style={{ textAlign: "center", margin: "0 auto", display: "grid" }}
                                className={this.state.authorizedCheckFlag ? "button-submit" : "button-cancel"} id="savebtn"
                                disabled={!this.state.authorizedCheckFlag}
                                type="submit"
                            >Continue</Button>
                        </Form >
                    </div>
                </div>

                <ModalFooter />
            </Modal>
        )
    }
}



export default AccountRegistration;